import {useState} from 'react';
import {useForm} from '@tanstack/react-form';
import {ArticleProductionStepSearchQueryFormValues} from './article-steps-copy.models';
import {EvNavigationButtons} from '../../pagination/ev-navigation-buttons';
import {EvInputField} from '../../form/EvInputField';
import {clsx} from 'clsx';
import {EvLoadingTanStackQuery} from '../../components/loading/ev-loading-tan-stack-query';
import {ArticleStepsSearchListRow} from './article-steps-search-list-row';
import {EvLoadingSpinner} from '../../components/loading/ev-loading-spinner';
import {useArticleStepsCopyListQuery} from './use-article-steps-copy-list-query';

const defaultValues: ArticleProductionStepSearchQueryFormValues = {
  oaNr: '',
  sdsNr: '',
  showDeleted: false,
  page: 1,
};

interface Props {
  selected: string | null;
  selectionChanged: (selection: string) => void;
}

export function ArticleStepsSearchList(props: Props) {
  const [queryForm, setQueryForm] = useState(defaultValues);
  const form = useForm({
    defaultValues: defaultValues,
    onSubmit: ({formApi}) => {
      setQueryForm(formApi.state.values);
    },
    listeners: {
      onChange: ({formApi}) => {
        setQueryForm(formApi.state.values);
      },
      onChangeDebounceMs: 750,
    },
  });

  const list = useArticleStepsCopyListQuery(
    {
      oaNr: !queryForm.oaNr ? null : queryForm.oaNr,
      sdsNr: !queryForm.sdsNr ? null : queryForm.sdsNr,
      showDeleted: queryForm.showDeleted ? true : null,
      page: queryForm.page,
    });
  return <form onSubmit={async (e) => {
    e.preventDefault();
    await form.handleSubmit();
  }}>
    <div className="min-h-144">
      <div className="grid gap-0 grid-cols-4 border-0 border-b border-solid border-[#ddd]">
        <div className="grid col-span-4 grid-cols-4 grid-rows-subgrid text-[15px]">
          <div className="p-2"></div>
          <div className="p-2">0A-Nr.</div>
          <div className="p-2">SDS-Nr.</div>
          <div className="p-2"></div>
        </div>
        <div className="grid col-span-4 grid-cols-4 grid-rows-subgrid
                        bg-whitetable-header-background
                        border border-solid border-whitetable-border border-b-0">
          <div className="p-2">
          </div>

          <div className="p-2">
            <form.Field name="oaNr">
              {(field) => <EvInputField field={field}/>}
            </form.Field>
          </div>

          <div className="p-2">
            <form.Field name="sdsNr">
              {(field) => <EvInputField field={field}/>}
            </form.Field>
          </div>

          <div className="p-2">
            <form.Field name="showDeleted">
              {(field) =>
                <div className="w-8 cursor-pointer"
                     title={field.state.value ? 'Gelöschte ausblenden' : 'Gelöschte anzeigen'}
                     onClick={() => field.handleChange(!field.state.value)}>
                  <i className={clsx(
                    'fa',
                    'fa-2x',
                    'fa-trash-o',
                    {
                      'text-storz-red': field.state.value,
                      'text-gray-500': !field.state.value,
                    })}/>
                </div>
              }
            </form.Field>
          </div>
        </div>

        <EvLoadingTanStackQuery query={list}>
          {{
            success: (data) =>
              data.objects.map(p =>
                <ArticleStepsSearchListRow key={p.oaNr}
                                           element={p}
                                           isSelected={p.oaNr === props.selected}
                                           onSelect={() => props.selectionChanged(p.oaNr)}
                />),
            error:
              <div className="col-span-4 text-center">Fehler beim laden der Artikel</div>,
            loading:
              <div className="col-span-4 bg-white min-h-10 border border-solid border-whitelist-border border-b-0">
                <EvLoadingSpinner/>
              </div>,
          }}
        </EvLoadingTanStackQuery>
      </div>
    </div>

    <form.Field name="page">
      {
        (field) =>
          <EvNavigationButtons page={field.state.value}
                               pagesTotal={list.data?.pages ?? 1}
                               setPage={field.handleChange}/>
      }
    </form.Field>
  </form>;
}
